import { Chip, TableCell, Typography } from '@mui/material';
import courseSyncService from '../../services/courseSyncService';
import CourseImportSync from './CourseImportSync';

export default function WebinarCourseImport() {
  return (
    <CourseImportSync
      syncAction={courseSyncService.syncWebinars}
      loadingMessage="Syncing webinar courses… this may take a minute."
      pulledLabel="Webinars"
      renderSummaryExtras={(result) => (
        <>
          {result.scheduledInstanceCount > 0 && (
            <Chip label={`${result.scheduledInstanceCount} Scheduled Dates`} size="small" variant="outlined" />
          )}
        </>
      )}
      renderTableHeadExtras={() => (
        <>
          <TableCell align="right">Active Dates</TableCell>
          <TableCell align="right">Inactivated</TableCell>
        </>
      )}
      renderTableRowExtras={(course) => (
        <>
          <TableCell align="right">
            {course.instancesActive > 0 ? course.instancesActive : '—'}
          </TableCell>
          <TableCell align="right">
            {course.instancesInactivated > 0 ? (
              <Typography variant="body2" color="error.main">
                {course.instancesInactivated}
              </Typography>
            ) : '—'}
          </TableCell>
        </>
      )}
    />
  );
}
